// extracted by mini-css-extract-plugin
module.exports = {"title":"ExclusiveDiscount_index_title__1bQzp","content":"ExclusiveDiscount_index_content__3DscH","reviewStatus":"ExclusiveDiscount_index_reviewStatus__1VFdJ"};